// The browser ignores an anchor's download name when the file lives on another host, and the video
// host is one, so a plain link opens the file in a tab instead of saving it. Reading the bytes
// first and saving them from a same-page address keeps the name; the video host allows the read.
export default function saveFile(url, filename) {
  return fetch(url)
    .then(response => {
      if (!response.ok) throw new Error(`File ${filename} answered HTTP ${response.status}`)
      return response.blob()
    })
    .then(blob => {
      const objectUrl = URL.createObjectURL(blob)
      const link = document.createElement('a')
      link.href = objectUrl
      link.download = filename
      document.body.appendChild(link)
      link.click()
      link.remove()
      // revoking in the same tick can cancel the save in some browsers
      setTimeout(() => URL.revokeObjectURL(objectUrl), 0)
    })
    .catch(() => {
      // a read that fails still leaves the researcher the file, as the plain link did
      window.open(url, '_blank', 'noopener,noreferrer')
    })
}
